import "public-path";
import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "reportWebVitals";
import dotenv from "dotenv";
import App from "App";

import "lib/utils/fontAwesomeIcons";
import { EmbeddedAppProps } from "lib/context/EmbeddedContext";

dotenv.config();

function domElementGetter({ container }: EmbeddedAppProps) {
  return container
    ? (container.querySelector("#root") as Element)
    : (document.querySelector("#root") as Element);
}

export async function bootstrap(): Promise<void> {
  // eslint-disable-next-line no-console
  console.log(`WIS app bootstraped`);
}

export async function mount(props: EmbeddedAppProps): Promise<void> {
  ReactDOM.render(<App {...props} />, domElementGetter(props));
}

export async function unmount(props: EmbeddedAppProps): Promise<void> {
  ReactDOM.unmountComponentAtNode(domElementGetter(props));
}

// eslint-disable-next-line no-underscore-dangle
if (!window.__POWERED_BY_QIANKUN__) {
  ReactDOM.render(<App />, domElementGetter({}));
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
